module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-2.617e1823.png";